/**
 * Alert service.
 */

import Vue from "vue";
import Toasted from "vue-toasted";

Vue.use(Toasted, { "position": "bottom-center" })

export default {
  /**
   * Emits an alert event.
   * @param alertEvent Alert event.
   */
  alert(alertEvent) {
    this.showToast(alertEvent.message)
  },

  /**
   * Emits an alert event.
   * @param message : message to alert
   */
  showToast(message, duration = 3) {
    Vue.toasted.show(message, { duration: duration * 1000 });
  }
};
